import { render, staticRenderFns } from "./ProjectSelect.vue?vue&type=template&id=38188086&scoped=true&"
import script from "./ProjectSelect.vue?vue&type=script&lang=js&"
export * from "./ProjectSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38188086",
  null
  
)

export default component.exports